import { createGate, useStore } from 'effector-react';
import { StatusInformer } from '@ui/status-informer';
import { Outlet } from 'react-router-dom';
import { $isAuthorized, $isAuthorizing } from '@@/auth/store/auth.store';
import { NoAuthorizedPage } from '@@/auth/pages/no-authorized';

export * from 'react-router';
export * from 'react-router-dom';
export const AppGate = createGate();

export const ProtectedRoutes = () => {
  const isAuthorized = useStore($isAuthorized);
  const isAuthorizing = useStore($isAuthorizing);

  if (!isAuthorized) return <NoAuthorizedPage />;
  return (
    <>
      <AppGate />
      <Outlet />
    </>
  );
};

export const AppRoot = () => (
  <>
    <Outlet />
    <StatusInformer />
    <div id="modal-root"></div>
  </>
);
